import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const RejectedRenewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewRejectedApplications.role,
    permissionsConfig.editRenewRejectedApplications.action,
    permissionsConfig.editRenewRejectedApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewRejectedApplications.role,
    permissionsConfig.deleteRenewRejectedApplications.action,
    permissionsConfig.deleteRenewRejectedApplications.type
  );
  
  return (
    <StatusApplication appStatus="11" title="Rejected" subTitle="Rejected" application_type="1" pageFrom="renew/payment-document-rejected" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default RejectedRenewApplications